/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment';
import clsx from 'clsx';
// import custom component
import { useHistory } from 'react-router-dom';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import * as AppConstants from '../../../../SharedModules/AppConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import SearchTypeComponent from '../../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
// import custom function handling
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  validDate,
  upperCaseFirstLetter,
  lowerCaseAllWordsExceptFirstLetters,
  checkQuarterValidation,
  compareQtrs,
  handleScrollToEvent,
  redirectURLLink,
  getQuarterVals,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';

import {
  MinDate,
  MaxDate,
  rebateProgramLabelName,
  viewPortHeight_355,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { getCheckBoxValue } from '../../../Research/InvoiceAudits/store/Actions';
import {
  handleErrorMessages,
  handleSuccessMessages,
  dispatchManufacturerData,
  dispatchCalculateInterest,
  getValidationCalculateInterestList,
  getCalculateInterestList,
  setCalInterestTab,
  getManufacturerList,
  getCommonDropdownList,
  dispatchValidationCalculateInterest,
  calcInterestDetail,
  ndcForDetail,
  displayNetworkErr,
} from '../store/Actions';
import { TableHeaderForManufacturer } from './gridComponents/tableHead';
import { START_QTR, END_QTR } from './constant';
import {
  calculatedInterestPayload,
  calculateUserInputs,
  fetchSearchScreenReduxData,
  updateCalculatedInterestData,
} from '../../../Display/CalculatedInterest/store/actions';

const CalculateInterestSearch = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  /* dispatch function */
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const calInterestTabRedux = useSelector((state) => {
    return state.sharedState.CalculateInterestReducer.calInterestObj;
  });
  const details_for_dsn = useSelector((state) => {
    return state.sharedState.CalculateInterestReducer.details_for_dsn;
  });
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.CalculateInterestReducer?.errorMessagesInRedux;
  });
  const successMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.CalculateInterestReducer?.successMessageInRedux;
  });
  const userDefaults = useSelector((state) => {
    return state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data;
  });
  const getPlanTypeData = useSelector((state) => {
    return state?.sharedState.InvoiceAuditsReducer?.checkbox;
  });

  const apiFailedErr = useSelector((state) => {
    return state?.sharedState.CalculateInterestReducer?.apiFailedErr;
  });
  const getRebateProgramList = useSelector((state) => {
    return state?.sharedState.CalculateInterestReducer?.dropdown;
  });
  const calculateInterestData = useSelector((state) => {
    return state?.sharedState.CalculateInterestReducer
      ?.getAllCalculateInterestList;
  });
  const fetchManufacturerGridList = useSelector((state) => {
    return state?.sharedState.CalculateInterestReducer?.manufacturerList;
  });
  const validationCalInterestData = useSelector((state) => {
    return state?.sharedState.CalculateInterestReducer
      ?.getAllVerifyCalInterestList;
  });
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const errorMessagesOfSearchTypeComp =
    errorMessagesFromRedux?.searchScreenErrors?.length > 0
      ? _.filter(
          errorMessagesFromRedux?.searchScreenErrors,
          (l) => l?.errorComponent === 'searchTypeComponent' && l.message
        ).map((val) => val)
      : [];
  // variable deceleration
  const searchCompObj = calInterestTabRedux?.state?.searchTypeState;
  const gridRef = React.useRef();
  const [flag,setFlag] = useState(false);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [planTypeOptions, setPlanTypeOptions] = useState([]);
  const [rebateProgramList, setRebateProgramList] = useState([]);
  const [errorMessagesList, setErrorMessagesList] = useState([]);
  const [errorCount, setErrorCount] = useState(null);
  const [open, setOpen] = useState(false);
  const [showOkBtn, setShowOkBtn] = useState(false);
  const [runType, setRunType] = useState('');
  const [labelerFullScreen, setLabelerFullScreen] = useState(
    searchCompObj?.labelerFullScreenRedux
      ? searchCompObj?.labelerFullScreenRedux
      : false
  );
  const [ndcLeftFullScreen, setNdcLeftFullScreen] = useState(
    searchCompObj?.ndcLeftFullScreenRedux
      ? searchCompObj?.ndcLeftFullScreenRedux
      : false
  );
  const [ndcRightFullScreen, setNdcRightFullScreen] = useState(
    searchCompObj ? searchCompObj.ndcRightFullScreenRedux : false
  );
  const [labelerSelectedRow, setLabelerSelectedRow] = useState(
    searchCompObj?.labelerSelectedRowRedux
      ? searchCompObj?.labelerSelectedRowRedux
      : ''
  );
  const [ndcLeftSelectedRows, setNdcLeftSelectedRows] = useState(
    searchCompObj?.ndcLeftSelectedRowsRedux
      ? searchCompObj?.ndcLeftSelectedRowsRedux
      : []
  );
  const [ndcRightSelectedRows, setNdcRightSelectedRows] = useState(
    searchCompObj?.ndcRightSelectedRowsRedux
      ? searchCompObj?.ndcRightSelectedRowsRedux
      : []
  );
  const [labelerTableData, setlabelerTableData] = useState(
    searchCompObj?.labelerTableDataRedux
      ? searchCompObj?.labelerTableDataRedux
      : []
  );
  const [ndcLeftTableData, setNdcLeftTableData] = useState(
    searchCompObj?.ndcLeftTableDataRedux
      ? searchCompObj?.ndcLeftTableDataRedux
      : []
  );
  const [ndcRightTableData, setNdcRightTableData] = useState(
    searchCompObj?.ndcRightTableDataRedux
      ? searchCompObj?.ndcRightTableDataRedux
      : []
  );
  const [ndcSearchVal, setNdcSearchVal] = useState(
    searchCompObj?.ndcSearchTextRedux ? searchCompObj?.ndcSearchTextRedux : ''
  );
  const [ndcNameSearchVal, setNdcNameSearchVal] = useState(
    searchCompObj?.ndcNameSearchTextRedux
      ? searchCompObj?.ndcNameSearchTextRedux
      : ''
  );
  const [errorMsgFromSearchType, setErrorMsgFromSearchType] = useState(
    errorMessagesOfSearchTypeComp
  );
  const [confirmAction, setConfirmAction] = React.useState(false);
  const [pendingSelection, setPendingSelection] = React.useState(false);

  
  const [validateArray, setValidateArray] = useState([]);
  const [arrayIdVO, setArrayIdVO] = useState([]);
  const [dropDownList, setDropDownList] = useState([]);
  const [state, setState] = useState(
    calInterestTabRedux?.state
      ? calInterestTabRedux.state
      : {
          asOfDate: new Date(),
          startingQtr: '',
          endingQtr: '',
          allQtr: false,
          validationFor: '',
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
          chooseBy: 'NDC',
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        }
  );
  const [searchType, setSearchType] = useState(
    searchCompObj && searchCompObj.valueSelectedRedux
      ? searchCompObj && searchCompObj.valueSelectedRedux
      : userDefaults?.defNdcSelectModeCd
      ? userDefaults?.defNdcSelectModeCd === 'NDC'
        ? 'NDC'
        : upperCaseFirstLetter(
            lowerCaseAllWordsExceptFirstLetters(
              userDefaults?.defNdcSelectModeCd
            )
          )
      : 'NDC'
  );

  // call initial API service on page load
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(dispatchCalculateInterest([]));
    if (!getPlanTypeData?.PLAN_TYPE_CD) {
      dispatch(getCheckBoxValue('PLAN_TYPE_CD'));
    }
  }, []);
  // handling onPage load call service
  React.useEffect(() => {
    if (calInterestTabRedux && Object.keys(calInterestTabRedux).length === 0) {
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
      dispatch(handleSuccessMessages([]));
      dispatch(dispatchManufacturerData([]));
    } else if (calInterestTabRedux?.fullScreenView) {
      setFullScreenView(calInterestTabRedux.fullScreenView);
    }
  }, []);
  // handing refresh functionality
  React.useEffect(() => {
    const searchObj = {
      valueSelectedRedux: searchType || 'NDC',
      ndcSearchTextRedux: ndcSearchVal || '',
      ndcNameSearchTextRedux: ndcNameSearchVal || '',
      ndcLeftTableDataRedux: ndcLeftTableData || [],
      ndcRightTableDataRedux: ndcRightTableData || [],
      labelerTableDataRedux: labelerTableData || [],
      ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
      ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
      labelerSelectedRowRedux: labelerSelectedRow || '',
      labelerFullScreenRedux: labelerFullScreen,
      ndcLeftFullScreenRedux: ndcLeftFullScreen,
      ndcRightFullScreenRedux: ndcRightFullScreen,
    };
    setState({ ...state, searchTypeState: searchObj });
    dispatch(
      setCalInterestTab({
        ...calInterestTabRedux,
        state: { ...state, searchTypeState: searchObj },
      })
    );
    dispatch(displayNetworkErr(false));
  }, [
    searchType,
    labelerSelectedRow,
    ndcLeftSelectedRows,
    ndcRightSelectedRows,
    labelerTableData,
    ndcLeftTableData,
    ndcRightTableData,
    ndcSearchVal,
    ndcNameSearchVal,
    labelerFullScreen,
    ndcLeftFullScreen,
    ndcRightFullScreen,
  ]);
  // handing highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.searchScreenErrors &&
      errorMessagesFromRedux?.searchScreenErrors.length > 0
    ) {
      tabHighLigther('/calculateInterest', true);
    } else {
      tabHighLigther('/calculateInterest', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // handing full screen view
  React.useEffect(() => {
    if (labelerFullScreen || ndcLeftFullScreen || ndcRightFullScreen) {
      setFullScreenView(true);
      const searchObj = {
        valueSelectedRedux: searchType || 'NDC',
        ndcSearchTextRedux: ndcSearchVal || '',
        ndcNameSearchTextRedux: ndcNameSearchVal || '',
        ndcLeftTableDataRedux: ndcLeftTableData || [],
        ndcRightTableDataRedux: ndcRightTableData || [],
        labelerTableDataRedux: labelerTableData || [],
        ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
        ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
        labelerSelectedRowRedux: labelerSelectedRow || '',
        labelerFullScreenRedux: labelerFullScreen,
        ndcLeftFullScreenRedux: ndcLeftFullScreen,
        ndcRightFullScreenRedux: ndcRightFullScreen,
      };

      dispatch(
        setCalInterestTab({
          ...calInterestTabRedux,
          fullScreenView: true,
          state: { ...state, searchTypeState: searchObj },
        })
      );
    } else {
      setFullScreenView(false);
      dispatch(
        setCalInterestTab({
          ...calInterestTabRedux,
          fullScreenView: false,
          state: state,
        })
      );
    }
  }, [labelerFullScreen, ndcLeftFullScreen, ndcRightFullScreen]);
  React.useEffect(() => {
    getCommonDropdownList(state.planTypeCd).then((resp) => {
      setDropDownList(resp);
    });
  }, [state.planTypeCd]);
  React.useEffect(() => {
    const planList =
      getPlanTypeData &&
      getPlanTypeData.PLAN_TYPE_CD &&
      getPlanTypeData.PLAN_TYPE_CD.length > 0 &&
      getPlanTypeData.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj?.codeValueID?.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
    setPlanTypeOptions(planList);
  }, [getPlanTypeData]);
  // handing by default multiple row selection function
  const onGridReady = (params) => {
    if (fetchManufacturerGridList && fetchManufacturerGridList?.length > 0) {
      params.api.forEachNode(
        (node) =>
          node.rowIndex ===
            fetchManufacturerGridList.findIndex((x) => {
              return x.mfgId === node.data.mfgId && x.value;
            }) && node.setSelected(true)
      );
    }
  };
  // set Rebate Program List
  React.useEffect(() => {
    let list = [];
    if (
      dropDownList?.status === constantMessageData.STATUS_MSG &&
      dropDownList?.message === constantMessageData.SUCCESS_MSG
    ) {
      if (!_.isEmpty(dropDownList.data)) {
        list = _.map(dropDownList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [dropDownList]);

  const detailNavigation = async () => {
    const payload = {
      planTypeCd: state?.planTypeCd,
      chooseBy: state?.chooseBy === 'M' ? 'MFG' : 'NDC',
      drugSeqNumList:
        details_for_dsn?.length && state?.chooseBy !== 'M'
          ? details_for_dsn
              ?.sort((a, b) => a.drugSeqNum - b.drugSeqNum)
              ?.map((item) => {
                return item.drugSeqNum;
              })
          : null,
      mfgId:
        fetchManufacturerGridList?.length > 0 && state?.chooseBy === 'M'
          ? fetchManufacturerGridList
              ?.filter((x) => {
                return x.value;
              })
              ?.sort((a, b) => a.mfgId - b.mfgId)
              ?.map((item) => {
                return item.mfgId;
              })
          : null,
      startQtr: state?.startingQtr,
      endQtr: state?.endingQtr,
      allQtrs: state?.allQtr,
      rebateProgramCd: state?.rebateProgramCd,
      byMfg: state?.chooseBy === 'M' ? '1' : '0',
    };
    const selectedData = {
      planType: state?.planTypeCd,
      selectType: state?.chooseBy === 'M' ? 'MFG' : 'NDC',
      rebateData: rebateProgramList,
      paidDateRange: !state?.allQtr
        ? {
            paidDateRangeFrom: state?.startingQtr,
            paidDateRangeTo: state?.endingQtr,
          }
        : null,
      allQtr: state?.allQtr,
      manuTblData: state?.chooseBy === 'M' ? [] : [],
    };
    dispatch(fetchSearchScreenReduxData(state));
    dispatch(calculateUserInputs(selectedData));
    dispatch(calculatedInterestPayload(payload));
    const response = await dispatch(calcInterestDetail(payload));
    dispatch(updateCalculatedInterestData(response));
    redirectURLLink(
      '/calculated-interest-details',
      'Calculate Interest Details',
      history,
      dispatch
    );
  };

  // set message after click on Run now button
  React.useEffect(() => {
    if (calculateInterestData && calculateInterestData.status === '001') {
      if (runType === 'N') {
        dispatch(handleSuccessMessages([AppConstants.INVOICE_JOB_COMPLETE]));
        detailNavigation();
      }
      if (runType === 'L') {
        handleScrollToEvent();
        dispatch(
          handleSuccessMessages([constantMessageData.RUN_LATER_MESSAGE])
        );
      }
    }
  }, [calculateInterestData]);
  // set validation response on local variables
  React.useEffect(() => {
    if (validationCalInterestData?.idVos?.length > 0) {
      setArrayIdVO(validationCalInterestData.idVos);
    }
    if (
      validationCalInterestData?.errorMsg &&
      validationCalInterestData?.errorMsg?.length > 0
    ) {
      const arrLocal = [];
      let arrayListSelected = [];
      let difference = [];
      setErrorCount(validationCalInterestData?.errorCount);
      if (state?.chooseBy === 'NDC') {
        const ErrorMessage = validationCalInterestData?.errorMsg?.map(
          (item) => {
            if (
              ndcRightTableData?.filter((x) => {
                return item?.includes(`NDC ${x.drugSeqNum}`);
              }).length > 0
            ) {
              return `${item.replace(
                ndcRightTableData
                  ?.filter((x) => {
                    return item?.includes(`NDC ${x.drugSeqNum}`);
                  })
                  .map((prop) => {
                    return prop.drugSeqNum;
                  }),
                ndcRightTableData
                  ?.filter((x) => {
                    return item?.includes(`NDC ${x.drugSeqNum}`);
                  })
                  .map((elem) => {
                    return elem.ndc;
                  })
              )}`;
            }
            return item;
          }
        );
        arrayListSelected = ndcRightTableData;
        arrayListSelected?.length > 0 &&
          arrayListSelected.forEach((element) => {
            validationCalInterestData?.errorMsg?.length > 0 &&
              validationCalInterestData.errorMsg.forEach((err) => {
                if (err.includes(`NDC ${element.drugSeqNum}`)) {
                  arrLocal.push(element);
                }
              });
          });
        setErrorMessagesList(ErrorMessage);
        difference = arrayListSelected.filter((x) => !arrLocal.includes(x));
        setValidateArray([
          ...new Set(
            difference?.map((item) => {
              return item.drugSeqNum;
            })
          ),
        ]);
      } else if (state?.chooseBy === 'M') {
        arrayListSelected = fetchManufacturerGridList.filter(
          (item) => item?.value == true
        );

        arrayListSelected?.length > 0 &&
          arrayListSelected.forEach((element) => {
            validationCalInterestData?.errorMsg?.length > 0 &&
              validationCalInterestData.errorMsg.forEach((err) => {
                if (err.includes(`MFG ${element.mfgId}`)) {
                  arrLocal.push(element);
                }
              });
          });
        difference = arrayListSelected.filter((x) => !arrLocal.includes(x));
        setValidateArray([
          ...new Set(
            difference?.map((item) => {
              return item.mfgId;
            })
          ),
        ]);
        setErrorMessagesList(validationCalInterestData?.errorMsg);
      }
      if (difference?.length > 0) {
        setShowOkBtn(true);
      } else {
        setShowOkBtn(false);
      }
      setOpen(true);
    } else if (validationCalInterestData?.errorMsg) {
      handleCalculateInterestFunction(
        state?.chooseBy === 'M'
          ? fetchManufacturerGridList
              ?.filter((x) => {
                return x.value;
              })
              ?.map((prop) => {
                return prop.mfgId;
              })
          : ndcRightTableData?.map((prop) => {
              return prop.drugSeqNum;
            }),
        validationCalInterestData.idVos
      );
    } else if (
      validationCalInterestData?.errorMsg === null &&
      validationCalInterestData?.idVos === null &&
      validationCalInterestData?.errorCount === null
    ) {
      let errorMessages = [];
      if (state?.chooseBy === 'NDC') {
        errorMessages = ndcRightTableData?.map((item) => {
          return `Cannot find Contract for NDC ${item.ndc}`;
        }) || [];
      } 
      if (errorMessages?.length > 0) {
        setErrorMessagesList(errorMessages);
        setErrorCount(errorMessages.length);
        setShowOkBtn(false);
        setOpen(true);
      }
    }
  }, [validationCalInterestData]);

  // set Error messages for Search type Component
  const getErrorsFromSearchTypeComponent = (errors) => {
    if (errors) {
      let alreadyPresentErrors = errorMessagesFromRedux?.searchScreenErrors
        ? errorMessagesFromRedux?.searchScreenErrors
        : [];

      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );

      alreadyPresentErrors = alreadyPresentErrors.concat(errors);

      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
    }
  };
  // fetch Manufacture List onclick search button
  const handleFetchManufactureListData = () => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    dispatch(handleSuccessMessages([]));
    handleClearFilter();
    if (
      localErr?.filter((x) => {
        return (
          x.field === 'asOfDateRequired' ||
          x.field === 'dateFormatInvalid' ||
          x.field === 'compareDateGreater'
        );
      }).length === 0 &&
      state.rebateProgramCd !== null &&
      state.rebateProgramCd !== '-1' &&
      (checkQuarterValidation(state.startingQtr) || state?.allQtr)
    ) {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'rebateProgramCd' &&
          item.field !== 'notSelectedMFG' &&
          item.field !== 'startingQtr'
      );
      dispatch(dispatchManufacturerData([]));
      const tempObj = {
        rpc: state?.rebateProgramCd,
        startqtr: state && state.allQtr ? START_QTR : state?.startingQtr,
        endqtr: state && state.allQtr ? END_QTR : state?.endingQtr,
        mfgTypeCd:
          state?.planTypeCd === 'FD' || state?.planTypeCd === 'ST' ? 'G' : 'C',
      };
      dispatch(dispatchManufacturerData([]));
      dispatch(getManufacturerList(tempObj));
    } else {
      localErr = localErr?.filter(
        (item) =>
          item.field !== 'rebateProgramCd' && item.field !== 'startingQtr'
      );
      if (state.rebateProgramCd === null || state.rebateProgramCd === '-1') {
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      }
      if (!checkQuarterValidation(state.startingQtr) && !state.allQtr) {
        localErr.push({
          field: 'startingQtr',
          errorType: 'startingQtr',
          message: constantMessageData.VALIDATE_QUARTER_VALUE,
        });
      }
    }
    dispatch(
      handleErrorMessages({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
  };
  // check validation on click run now/run later button
  const handleValidationOnCalculateInterest = (NDCList) => {
    setShowOkBtn(false);
    dispatch(ndcForDetail(NDCList));
    dispatch(
      getValidationCalculateInterestList({
        validationFor: state?.chooseBy === 'M' ? 'MFG' : 'NDC',
        dsn:
          NDCList?.length > 0 && state?.chooseBy === 'NDC'
            ? NDCList?.sort((a, b) => a.drugSeqNum - b.drugSeqNum)?.map(
                (item) => {
                  return item.drugSeqNum;
                }
              )
            : null,
        mfgId:
          fetchManufacturerGridList?.length > 0 && state?.chooseBy === 'M'
            ? fetchManufacturerGridList
                ?.filter((x) => {
                  return x.value;
                })
                ?.sort((a, b) => a.mfgId - b.mfgId)
                ?.map((item) => {
                  return item.mfgId;
                })
            : null,
        asOfDate: state?.asOfDate
          ? moment(state?.asOfDate).format('MM/DD/YYYY')
          : null,
        startingQtr: state?.startingQtr ? state?.startingQtr : null,
        endingQtr: state?.endingQtr ? state?.endingQtr : null,
        rpc: state?.rebateProgramCd ? state?.rebateProgramCd : null,
        allQtr: state?.allQtr ? state?.allQtr : false,
      })
    );
  };
  // fetch calculate interest API call service
  const handleCalculateInterestFunction = (dataList, arrayVO) => {
    if (!arrayVO || arrayVO.length === 0) {
      return;
    }
    const diffVO = [];
    const startqtr = state && state.allQtr ? START_QTR : state?.startingQtr;
    const endqtr = state && state.allQtr ? END_QTR : state?.endingQtr;
    arrayVO.forEach((elem) => {
      dataList.forEach((elData) => {
        if (elem.id?.toString() === elData?.toString()) {
          diffVO.push({
            ...elem,
            startingQtr: getQuarterVals(startqtr),
            endingQtr: getQuarterVals(endqtr),
          });
        }
      });
    });
    if (runType) {
      dispatch(
        getCalculateInterestList({
          runFor: state?.chooseBy === 'M' ? 'MFG' : 'Ndc',
          runType: runType || 'N',

          userId: logInUser,
          asOfDate: state?.asOfDate
            ? moment(state?.asOfDate).format('MM/DD/YYYY')
            : null,

          progCd: state?.rebateProgramCd ? state?.rebateProgramCd : null,
          idResponseVOs: diffVO,
        })
      );
    }
  };
  const triggerValidation = (NDCList, name) => {
    if ((NDCList?.length || 0) > 1000) {
      setPendingSelection({
        list: NDCList.slice(0,1000),
        name,
      });
      setConfirmAction(true);
      return;
    }
    handleValidationForSelectedList(NDCList, name);
  };
  
  

  // check validation on Calculate Interest API call Service
  const handleValidationForSelectedList = (NDCList, name) => {
    let errorMessages = errorMessagesFromRedux?.searchScreenErrors || [];
    dispatch(handleSuccessMessages([]));
    if (
      errorMessages?.filter((x) => {
        return (
          x.field === 'asOfDateRequired' ||
          x.field === 'dateFormatInvalid' ||
          x.field === 'compareDateGreater'
        );
      }).length === 0 &&
      state.rebateProgramCd !== null &&
      state?.rebateProgramCd !== '-1' &&
      (checkQuarterValidation(state.startingQtr) || state?.allQtr)
    ) {
      errorMessages = errorMessages?.filter(
        (item) =>
          item.field !== 'rebateProgramCd' &&
          item.field !== 'startingQtr' &&
          item.field !== 'notSelectedMFG'
      );
      if (name === 'NDC') {
        if (NDCList?.length > 0 && NDCList.length > 0) {
          errorMessages = errorMessages?.filter(
            (item) => item.field !== 'notSelectedMFG'
          );
          handleValidationOnCalculateInterest(NDCList);
        } else {
          handleScrollToEvent();
          errorMessages.push({
            field: 'notSelectedMFG',
            errorType: 'notSelectedMFG',
            message: constantMessageData.NOT_SELECTED_ANY_MFG,
          });
        }
      }
      if (name === 'MFG') {
        if (
          fetchManufacturerGridList?.length > 0 &&
          fetchManufacturerGridList.filter((x) => {
            return x.value;
          }).length > 0
        ) {
          errorMessages = errorMessages?.filter(
            (item) => item.field !== 'notSelectedMFG'
          );
          handleValidationOnCalculateInterest();
        } else {
          handleScrollToEvent();
          errorMessages.push({
            field: 'notSelectedMFG',
            errorType: 'notSelectedMFG',
            message: constantMessageData.NOT_SELECTED_ANY_MFG,
          });
        }
      }
    } else {
      handleScrollToEvent();
      errorMessages = errorMessages?.filter(
        (item) =>
          item.field !== 'rebateProgramCd' &&
          item.field !== 'startingQtr' &&
          item.field !== 'notSelectedMFG'
      );
      if (state.rebateProgramCd === null || state.rebateProgramCd === '-1') {
        errorMessages.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      }
      if (!checkQuarterValidation(state.startingQtr) && !state.allQtr) {
        errorMessages.push({
          field: 'startingQtr',
          errorType: 'startingQtr',
          message: constantMessageData.VALIDATE_QUARTER_VALUE,
        });
      }
    }
    dispatch(
      handleErrorMessages({
        searchScreenErrors: [...new Set(errorMessages)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
  };
  // click on filter icon after call
  const handleClearFilter = () => {
    if (
      fetchManufacturerGridList &&
      fetchManufacturerGridList.length > 0 &&
      gridRef?.current
    ) {
      gridRef.current.clearFilters();
    }
  };
  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    dispatch(
      setCalInterestTab({
        fullScreenView: !fullScreenView,
        state: state,
      })
    );
  };
  // call on Blur event &OnChange even As of date filed level
  const handleOnBlurDateEvent = (d, event) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    dispatch(handleSuccessMessages([]));
    if (d != 'Invalid Date') {
      let value = null;
      if (event === 'onBlur' && d.target.value && d.target.value.length > 5) {
        const data = d.target.value.split('/');
        if (data[2].split('_').length === 3) {
          value = moment(d.target.value, 'MM/DD/YY').format('MM/DD/YYYY');
        } else {
          value = d.target.value;
        }
      } else {
        value = event === 'onBlur' ? d.target.value : d;
      }
      let showError = false;
      if (value === null || value === '') {
        localErr = localErr?.filter((item) => {
          return (
            item.field !== 'dateFormatInvalid' &&
            item.field !== 'compareDateGreater' &&
            item.field !== 'notSelectedMFG'
          );
        });
        showError = true;
        localErr.push({
          field: 'asOfDateRequired',
          errorType: 'asOfDateRequired',
          message: constantMessageData.AS_OF_DATE_REQUIRED,
        });
        setState({ ...state, asOfDate: value });
        dispatch(
          setCalInterestTab({
            fullScreenView: fullScreenView,
            state: { ...state, asOfDate: value },
          })
        );
      } else if (validDate(new Date(value)) === false) {
        localErr = localErr?.filter((item) => {
          return (
            item.field !== 'compareDateGreater' &&
            item.field !== 'asOfDateRequired' &&
            item.field !== 'notSelectedMFG'
          );
        });
        showError = true;
        localErr.push({
          field: 'dateFormatInvalid',
          errorType: 'InvalidDate',
          message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
        });
        setState({ ...state, asOfDate: value });
        dispatch(
          setCalInterestTab({
            fullScreenView: fullScreenView,
            state: { ...state, asOfDate: value },
          })
        );
      } else if (compareTwoDatesGreaterThanOrEqual(value, moment(MinDate))) {
        localErr = localErr?.filter((item) => {
          return (
            item.field !== 'dateFormatInvalid' &&
            item.field !== 'asOfDateRequired' &&
            item.field !== 'notSelectedMFG'
          );
        });
        showError = true;
        localErr.push({
          field: 'compareDateGreater',
          errorType: 'compareDate',
          message: constantMessageData.MINIMUM_AS_OF_DATE,
        });
        setState({ ...state, asOfDate: value });
        dispatch(
          setCalInterestTab({
            fullScreenView: fullScreenView,
            state: { ...state, asOfDate: value },
          })
        );
      }
      if (!showError) {
        localErr = localErr?.filter((item) => {
          return (
            item.field !== 'dateFormatInvalid' &&
            item.field !== 'compareDateGreater' &&
            item.field !== 'asOfDateRequired' &&
            item.field !== 'notSelectedMFG'
          );
        });
        setState({ ...state, asOfDate: value });
        dispatch(
          setCalInterestTab({
            fullScreenView: fullScreenView,
            state: { ...state, asOfDate: value },
          })
        );
      }
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(localErr)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
    }
  };
  const onChangeDateField = (d, name) => {
    if (d !== 'Invalid Date') {
      setState({
        ...state,
        asOfDate: d,
        searchTypeState: {
          valueSelectedRedux: 'NDC',
          ndcSearchTextRedux: '',
          ndcNameSearchTextRedux: '',
          ndcLeftTableDataRedux: [],
          ndcRightTableDataRedux: [],
          labelerTableDataRedux: [],
          ndcLeftSelectedRowsRedux: [],
          ndcRightSelectedRowsRedux: [],
          labelerSelectedRowRedux: '',
          ndcLeftFullScreenRedux: false,
          ndcRightFullScreenRedux: false,
          labelerFullScreenRedux: false,
        },
      });
    }
  };
  // check validation for rebate program Dropdown
  const handleOnBlurEventOnFields = (value, name, type) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    dispatch(handleSuccessMessages([]));
    if (name === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'notSelectedMFG'
        );
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'notSelectedMFG'
        );
      }
    }
    if (type === 'quarter') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) => item.field !== name && item.field !== 'notSelectedMFG'
          );
          if (name === 'startingQtr') {
            localErr = localErr?.filter(
              (item) =>
                item.field !== 'endingQtr' && item.field !== 'notSelectedMFG'
            );
            if (state?.endingQtr) {
              if (compareQtrs(value, state.endingQtr)) {
                localErr.push({
                  field: 'endingQtr',
                  errorType: 'invalidFormat',
                  message: constantMessageData.END_QTR_GRATER_START_QTR_CI,
                });
              } else {
                localErr = localErr?.filter(
                  (item) =>
                    item.field !== 'endingQtr' && item.field !== 'startingQtr'
                );
              }
              setState({
                ...state,
                startingQtr: autoFormateDate(value?.toUpperCase()),
              });
              dispatch(
                setCalInterestTab({
                  fullScreenView: fullScreenView,
                  state: {
                    ...state,
                    startingQtr: autoFormateDate(value?.toUpperCase()),
                  },
                })
              );
            } else {
              setState({
                ...state,
                startingQtr: autoFormateDate(value?.toUpperCase()),
                endingQtr: autoFormateDate(value?.toUpperCase()),
              });
              dispatch(
                setCalInterestTab({
                  fullScreenView: fullScreenView,
                  state: {
                    ...state,
                    startingQtr: autoFormateDate(value?.toUpperCase()),
                    endingQtr: autoFormateDate(value?.toUpperCase()),
                  },
                })
              );
            }
          }
          if (name === 'endingQtr') {
            if (state?.startingQtr) {
              if (compareQtrs(state.startingQtr, value)) {
                localErr.push({
                  field: 'endingQtr',
                  errorType: 'invalidFormat',
                  message: constantMessageData.END_QTR_GRATER_START_QTR_CI,
                });
              } else {
                localErr = localErr?.filter(
                  (item) =>
                    item.field !== 'endingQtr' && item.field !== 'startingQtr'
                );
              }
            }

            setState({
              ...state,
              endingQtr: autoFormateDate(value?.toUpperCase()),
            });
            dispatch(
              setCalInterestTab({
                fullScreenView: fullScreenView,
                state: {
                  ...state,
                  endingQtr: autoFormateDate(value?.toUpperCase()),
                },
              })
            );
          }
        } else {
          localErr = localErr?.filter(
            (item) => item.field !== name && item.field !== 'notSelectedMFG'
          );
          localErr.push({
            field: name,
            errorType: 'invalidFormat',
            message: constantMessageData.VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr?.filter(
          (item) => item.field !== name && item.field !== 'notSelectedMFG'
        );
        localErr.push({
          field: name,
          errorType: 'invalidFormat',
          message: constantMessageData.VALIDATE_QUARTER_VALUE,
        });
      }
    }
    dispatch(
      handleErrorMessages({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
  };
  // handing On change event on filed level
  const handleOnChangeEvent = (value, name) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    dispatch(handleSuccessMessages([]));
    if (name === 'chooseBy' && value !== state.chooseBy) {
      setState({
        ...state,
        chooseBy: value,
        searchTypeState: {
          valueSelectedRedux: 'NDC',
          ndcSearchTextRedux: '',
          ndcNameSearchTextRedux: '',
          ndcLeftTableDataRedux: [],
          ndcRightTableDataRedux: [],
          labelerTableDataRedux: [],
          ndcLeftSelectedRowsRedux: [],
          ndcRightSelectedRowsRedux: [],
          labelerSelectedRowRedux: '',
          ndcLeftFullScreenRedux: false,
          ndcRightFullScreenRedux: false,
          labelerFullScreenRedux: false,
        },
      });
      setSearchType(
        userDefaults?.defNdcSelectModeCd
          ? userDefaults?.defNdcSelectModeCd === 'NDC'
            ? 'NDC'
            : upperCaseFirstLetter(
                lowerCaseAllWordsExceptFirstLetters(
                  userDefaults?.defNdcSelectModeCd
                )
              )
          : 'NDC'
      );
      setNdcLeftSelectedRows([]);
      setLabelerSelectedRow('');
      setNdcRightSelectedRows([]);
      setlabelerTableData([]);
      setNdcLeftTableData([]);
      setNdcRightTableData([]);
      setNdcSearchVal('');
      setNdcNameSearchVal('');
      dispatch(
        setCalInterestTab({
          fullScreenView: fullScreenView,
          state: {
            ...state,
            searchTypeState: {
              valueSelectedRedux: 'NDC',
              ndcSearchTextRedux: '',
              ndcNameSearchTextRedux: '',
              ndcLeftTableDataRedux: [],
              ndcRightTableDataRedux: [],
              labelerTableDataRedux: [],
              ndcLeftSelectedRowsRedux: [],
              ndcRightSelectedRowsRedux: [],
              labelerSelectedRowRedux: '',
              ndcLeftFullScreenRedux: false,
              ndcRightFullScreenRedux: false,
              labelerFullScreenRedux: false,
            },
          },
        })
      );

      localErr = localErr.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      setErrorMsgFromSearchType([]);
    } else if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });

      dispatch(
        setCalInterestTab({
          fullScreenView: fullScreenView,
          state: { ...state, [name]: value, rebateProgramCd: '-1' },
        })
      );
    } else if (name === 'allQtr' && value) {
      localErr = localErr.filter(
        (item) => item.field !== 'startingQtr' && item.field !== 'endingQtr'
      );
      setState({ ...state, [name]: value, startingQtr: '', endingQtr: '' });
      dispatch(
        setCalInterestTab({
          fullScreenView: fullScreenView,
          state: { ...state, [name]: value, startingQtr: '', endingQtr: '' },
        })
      );
    } else {
      setState({ ...state, [name]: value });
      dispatch(
        setCalInterestTab({
          fullScreenView: fullScreenView,
          state: { ...state, [name]: value },
        })
      );
    }
    dispatch(
      handleErrorMessages({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
  };
  // cancel popup click cancel button
  const handelCancelClose = () => {
    setOpen(false);
    setShowOkBtn(false);
    dispatch(dispatchValidationCalculateInterest([]));
    setFlag(true)
  };
  React.useEffect(()=>{
    if (errorCount <= 25 && showOkBtn &&flag) {
        handleCalculateInterestFunction(
          validateArray,
          validationCalInterestData?.idVos
        );
        setFlag(false)
    }
  },[flag])
  // select row one by one in manufacturer table grid
  const onRowSelect = (rowData) => {
    const newObj = fetchManufacturerGridList?.map((item) => {
      if (
        rowData &&
        rowData?.filter((x) => {
          return x.mfgId === item.mfgId;
        }).length > 0
      ) {
        item.value = true;
      } else {
        item.value = false;
      }
      return item;
    });
    dispatch(dispatchManufacturerData(newObj));
  };
  // Ag-Grid table in framework components
  const frameworkComponents = {
    CheckBoxCellRender: (cellInfo) => {
      return (
        <>
          <div className="tbl-checkbox">
            <FormControlLabel
              control={<Checkbox color="primary" />}
              onClick={(e) => {
                cellInfo.node.setDataValue(
                  cellInfo.column.colId,
                  e.target.checked
                );
              }}
              checked={cellInfo.value}
              value={cellInfo.value}
              data-testid="checkBox_selected"
            />
          </div>
        </>
      );
    },
  };
  return (
    <>
      <div
        data-testid="search-component"
        className="tBillPanel custom-check tabs-container"
      >
        <CustomSeparator parent1="Tasks" parent2="Calculate Interest" />
        {!fullScreenView && (
          <>
            <DisplayErrorMessages
              errorMessages={[
                ...new Set(
                  errorMessagesFromRedux?.searchScreenErrors?.length > 0
                    ? _.map(
                        errorMessagesFromRedux.searchScreenErrors,
                        (l) => l.message
                      )
                    : []
                ),
              ]}
            />
            <DisplaySuccessMessages
              successMessages={successMessagesFromRedux}
            />
            {apiFailedErr && (
              <DisplayErrorMessages
                errorMessages={[constantMessageData.API_TIMEOUT_ERROR]}
              />
            )}
            <Spinner load={spinnerLoader} />
          </>
        )}
        {!fullScreenView && (
          <>
            <div className="row mb-sm-4">
              <div className="col-12 col-sm-3 col-md-2 col-lg-3 col-xl-2">
                <div className="">
                  <div className="mui-custom-form input-md">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        id="begin_date_net_association_bp_tab"
                        className="mandate-fields"
                        data-testid="as-of-date"
                        label="As of Date"
                        format="MM/dd/yyyy"
                        required
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          readOnly: false,
                          autoFill: false,
                        }}
                        placeholder="mm/dd/yyyy"
                        minDate={MinDate}
                        maxDate={MaxDate}
                        mask="__/__/____"
                        value={(state && state.asOfDate) || null}
                        onChange={(d) => {
                          onChangeDateField(d, 'asOfDate');
                        }}
                        onBlur={(e) => {
                          handleOnBlurDateEvent(e, 'onBlur');
                        }}
                        onKeyDown={async (e) => {
                          if (e.keyCode == 67) {
                            // copy date
                            await window.navigator?.clipboard.writeText(
                              e?.target?.value
                            );
                          }
                        }}
                        KeyboardButtonProps={{ 'aria-label': 'change date' }}
                        helperText={
                          errorMessagesFromRedux?.searchScreenErrors?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux?.searchScreenErrors
                                    ?.filter((x) => {
                                      return (
                                        x.field === 'compareDateGreater' ||
                                        x.field === 'asOfDateRequired' ||
                                        x.field === 'dateFormatInvalid'
                                      );
                                    })
                                    .map((item) => {
                                      return item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.searchScreenErrors?.length >
                            0 &&
                          errorMessagesFromRedux?.searchScreenErrors?.filter(
                            (x) => {
                              return (
                                x.field === 'compareDateGreater' ||
                                x.field === 'asOfDateRequired' ||
                                x.field === 'dateFormatInvalid'
                              );
                            }
                          ).length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux?.searchScreenErrors
                                    ?.filter((x) => {
                                      return (
                                        x.field === 'compareDateGreater' ||
                                        x.field === 'asOfDateRequired' ||
                                        x.field === 'dateFormatInvalid'
                                      );
                                    })
                                    .map((item) => {
                                      return item.message;
                                    })
                                ),
                              ]
                            : false
                        }
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-5 col-md-4 col-lg-5 col-xl-4">
                <div className="mui-zip-flex" style={{ display: 'contents' }}>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mui-custom-form input-md">
                        <TextField
                          className="mandate-fields"
                          id="startingQtr"
                          data-testid="startingQtr"
                          label="Quarter Range"
                          placeholder="From"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                          disabled={state?.allQtr}
                          inputProps={{ maxLength: 6 }}
                          value={state?.startingQtr}
                          onChange={(e) =>
                            handleOnChangeEvent(e.target.value, 'startingQtr')
                          }
                          onBlur={(e) =>
                            handleOnBlurEventOnFields(
                              e.target.value,
                              'startingQtr',
                              'quarter'
                            )
                          }
                          helperText={
                            errorMessagesFromRedux?.searchScreenErrors?.length >
                            0
                              ? [
                                  ...new Set(
                                    errorMessagesFromRedux?.searchScreenErrors
                                      ?.filter((x) => {
                                        return x.field === 'startingQtr';
                                      })
                                      .map((item) => {
                                        return item.message;
                                      })
                                  ),
                                ]
                              : null
                          }
                          error={
                            errorMessagesFromRedux?.searchScreenErrors?.length >
                              0 &&
                            errorMessagesFromRedux?.searchScreenErrors?.filter(
                              (x) => {
                                return x.field === 'startingQtr';
                              }
                            ).length > 0
                              ? [
                                  ...new Set(
                                    errorMessagesFromRedux?.searchScreenErrors
                                      ?.filter((x) => {
                                        return x.field === 'startingQtr';
                                      })
                                      .map((item) => {
                                        return item.message;
                                      })
                                  ),
                                ]
                              : false
                          }
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mui-custom-form input-md">
                        <TextField
                          className="mandate-fields frr-display-hidden-label"
                          id="endingQtr"
                          data-testid="endingQtr"
                          label="To"
                          fullWidth
                          placeholder="To"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled={state?.allQtr}
                          inputProps={{ maxLength: 6, id: 'endingQtr' }}
                          value={state?.endingQtr}
                          onChange={(e) => {
                            handleOnChangeEvent(e.target.value, 'endingQtr');
                          }}
                          onBlur={(e) => {
                            handleOnBlurEventOnFields(
                              e.target.value,
                              'endingQtr',
                              'quarter'
                            );
                          }}
                          helperText={
                            errorMessagesFromRedux?.searchScreenErrors?.length >
                            0
                              ? [
                                  ...new Set(
                                    errorMessagesFromRedux?.searchScreenErrors
                                      ?.filter((x) => {
                                        return x.field === 'endingQtr';
                                      })
                                      .map((item) => {
                                        return item.message;
                                      })
                                  ),
                                ]
                              : null
                          }
                          error={
                            errorMessagesFromRedux?.searchScreenErrors?.length >
                              0 &&
                            errorMessagesFromRedux?.searchScreenErrors?.filter(
                              (x) => {
                                return x.field === 'endingQtr';
                              }
                            ).length > 0
                              ? [
                                  ...new Set(
                                    errorMessagesFromRedux?.searchScreenErrors
                                      ?.filter((x) => {
                                        return x.field === 'endingQtr';
                                      })
                                      .map((item) => {
                                        return item.message;
                                      })
                                  ),
                                ]
                              : false
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-4 col-md-4">
                <div className="mui-custom-form input-md">
                  <FormControlLabel
                    className="frr-mt-26"
                    control={<Checkbox color="primary" />}
                    label="All Quarters"
                    data-testid="allQtr"
                    value={state.allQtr}
                    checked={state.allQtr}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.checked, 'allQtr')
                    }
                  />
                  {state?.chooseBy === 'M' && (
                    <div className="btn-wrapper float-right">
                      <Button
                        className="btn btn-success btn-search mt-3 frr-margin-right-45"
                        data-testid="search_btn"
                        onClick={() => {
                          handleFetchManufactureListData();
                        }}
                      >
                        <SVGComponent iconName="Icon-search" />
                        Search
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12 mt-3 col-sm-6 mt-sm-0 col-md-6 col-lg-6 col-xl-4  frr-two-col-radio">
                <RadioGroupComponent
                  data-testid="filter-plan-by-radio-btn-plan"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Plan Type"
                  required
                  optionList={planTypeOptions}
                  defaultValue={state && state.planTypeCd}
                  filterAction={(e) => handleOnChangeEvent(e, 'planTypeCd')}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-12 mt-3 col-sm-6 mt-sm-0 col-md-6 col-lg-6 col-xl-4  frr-two-col-radio">
                <RadioGroupComponent
                  data-testid="choseBy"
                  id="choseBy"
                  labelName="Choose by"
                  required
                  optionList={[
                    { name: 'NDC', value: 'NDC' },
                    { name: 'Manufacturer', value: 'M' },
                  ]}
                  defaultValue={state && state.chooseBy}
                  filterAction={(e) => handleOnChangeEvent(e, 'chooseBy')}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4  frr-two-col-radio mt-2">
                <fieldset
                  className={clsx(
                    'radioBtnGroup custom-fieldset frr-height-119'
                  )}
                >
                  <legend className="d-none" />
                  <div className="frr-mui-custom-form-width-96per">
                    <div className="form-wrapper">
                      <div className="mui-custom-form with-select">
                        <TextField
                          data-testid="rebate_program-ia"
                          id="rebate_program"
                          label={rebateProgramLabelName}
                          fullWidth
                          select
                          required
                          placeholder=""
                          inputProps={{ maxLength: 11, id: 'rebate_program' }}
                          onBlur={(e) =>
                            handleOnBlurEventOnFields(
                              e.target.value,
                              'rebateProgramCd'
                            )
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={state && state.rebateProgramCd}
                          onChange={(e) =>
                            handleOnChangeEvent(
                              e.target.value,
                              'rebateProgramCd'
                            )
                          }
                          className={
                            errorMessagesFromRedux?.searchScreenErrors?.length >
                            0
                              ? _.map(
                                  errorMessagesFromRedux.searchScreenErrors,
                                  (l) =>
                                    l.field === 'rebateProgramCd'
                                      ? 'mandate-fields'
                                      : null
                                )
                              : null
                          }
                          helperText={
                            errorMessagesFromRedux?.searchScreenErrors?.length >
                            0
                              ? _.map(
                                  errorMessagesFromRedux.searchScreenErrors,
                                  (l) =>
                                    l.field === 'rebateProgramCd'
                                      ? l.message
                                      : null
                                )
                              : null
                          }
                          error={
                            errorMessagesFromRedux?.searchScreenErrors?.length >
                            0
                              ? _.map(
                                  errorMessagesFromRedux.searchScreenErrors,
                                  (l) =>
                                    l.field === 'rebateProgramCd'
                                      ? l.message
                                      : null
                                )
                              : null
                          }
                        >
                          <MenuItem
                            key=""
                            value="-1"
                            className="frr-dropdown-blank-item"
                          />

                          {rebateProgramList &&
                          rebateProgramList.length &&
                          rebateProgramList.length > 0
                            ? rebateProgramList.map((item) => {
                                return (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </TextField>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </>
        )}

        {state && state.chooseBy === 'M' ? (
          <>
            {!fullScreenView && (
              <div className="clearfix">
                <div className="float-right btn-wrapper pt-4">
                  <div className=" display-inline-flex">
                    <div className="float-right">
                      <Button
                        id="name-filter-btn-id"
                        title="Run Now"
                        data-testid="run-Now-btn"
                        className="btn btn-success btn-search ml-1 float-right"
                        onClick={() => {
                          setRunType('N');
                          triggerValidation([], 'MFG');
                        }}
                      >
                        <SVGComponent iconName="Icon-run-now" /> {'  '} Run Now
                      </Button>
                    </div>
                    <div>
                      <Button
                        id="name-filter-btn-id"
                        title="Run Later"
                        data-testid="run-Later-btn"
                        className="btn btn-success btn-search ml-1 float-right"
                        onClick={() => {
                          setRunType('L');
                          triggerValidation([], 'MFG');
                        }}
                      >
                        <SVGComponent iconName="Icon-run-later" /> {'  '} Run
                        Later
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div
              id="testGrid"
              className="panel-body FRR-custom-table tbl-manufacturer-inner viewcalcmfgTbl"
            >
              <TableGrid
                ref={gridRef}
                gridCall={onGridReady}
                data-testid="manufacturer-table"
                rowSelection="multiple"
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
                rowData={fetchManufacturerGridList?.sort(
                  (a, b) => a.mfgId - b.mfgId
                )}
                onSelect={(e) => {
                  onRowSelect(e.api?.getSelectedRows());
                }}
                onSelectionChanged={(e) => {
                  onRowSelect(e.api?.getSelectedRows());
                }}
                columnDefs={TableHeaderForManufacturer}
                exportFile
                animateRows
                sideBar={false}
                fileName="Calculate Interest-Manufacturer"
                singleClickEdit
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
                frameworkComponents={frameworkComponents}
              />
            </div>
          </>
        ) : state && state.chooseBy === 'NDC' ? (
          <SearchTypeComponent
            id="Calculate Interest"
            data-testid="search-type-ci"
            runNowButtonName="Run Now"
            runLaterButtonName="Run Later"
            handleRunNowFunction={(data) => {
              setRunType('N');
              triggerValidation(data, 'NDC');
            }}
            handleRunLaterFunction={(data) => {
              setRunType('L');
              triggerValidation(data, 'NDC');
            }}
            searchType={searchType}
            setSearchType={setSearchType}
            getErrorsFromSearchTypeComponent={getErrorsFromSearchTypeComponent}
            errorMsgFromSearchType={errorMsgFromSearchType}
            setLabelerFullScreen={setLabelerFullScreen}
            labelerFullScreen={labelerFullScreen}
            setNdcLeftFullScreen={setNdcLeftFullScreen}
            ndcLeftFullScreen={ndcLeftFullScreen}
            setNdcRightFullScreen={setNdcRightFullScreen}
            ndcRightFullScreen={ndcRightFullScreen}
            setlabelerSelectedRow={setLabelerSelectedRow}
            labelerSelectedRow={labelerSelectedRow}
            setNdcLeftSelectedRows={setNdcLeftSelectedRows}
            ndcLeftSelectedRows={ndcLeftSelectedRows}
            setNdcRightSelectedRows={setNdcRightSelectedRows}
            ndcRightSelectedRows={ndcRightSelectedRows}
            setlabelerTableData={setlabelerTableData}
            labelerTableData={labelerTableData}
            setNdcLeftTableData={setNdcLeftTableData}
            ndcLeftTableData={ndcLeftTableData}
            setNdcRightTableData={setNdcRightTableData}
            ndcRightTableData={ndcRightTableData}
            setNdcSearchVal={setNdcSearchVal}
            ndcSearchVal={ndcSearchVal}
            setNdcNameSearchVal={setNdcNameSearchVal}
            ndcNameSearchVal={ndcNameSearchVal}
          />
        ) : null}
      </div>
      <CommonModal
        open={open}
        className="dialogPanel custom-check dialog-600 common-popup"
        data-testid="common-modal"
        viewAction
        viewHeader
        modalTitle="Validation For Calculate Interest"
        okTitle="Ok"
        closeTitle={errorCount <= 25 && showOkBtn ? 'Cancel' : false}
        removeClassName
        childrenComponent={
          <>
            <span className="frr-label-font d-block mb-2">
              {errorCount <= 25
                ? constantMessageData.ERROR_COUNT_LESS_THAN_25
                : constantMessageData.ERROR_COUNT_GREATER_THAN_25}
            </span>
            <div>
              <ol type="1">
                {errorMessagesList &&
                  errorMessagesList?.map((item, index) => {
                    if (index < 25) {
                      return <li>{`${item}.`}</li>;
                    }
                  })}
              </ol>
            </div>
            <span className="frr-label-font">
              {errorCount <= 25 && showOkBtn
                ? AppConstants.ERROR_COUNT_FOOTER_MSG
                : null}
            </span>
          </>
        }
        onOk={() => {
            handleCalculateInterestFunction(
            validateArray,
            validationCalInterestData?.idVos
        );
          handelCancelClose();
        }}
        onClose={handelCancelClose}
      />
       <CommonModal
    open={confirmAction}
    viewAction
    className="dialog-420"
    viewHeader
    modalTitle="Confirmation Dialog"
    okTitle="Yes"
    closeTitle="No"
    childrenComponent={constantMessageData.NDC_LIMIT_TO_1000}
    onClose={() => {
      setConfirmAction(false);
      setPendingSelection({
        list: [],
        name: '',
      });
    }}
    onOk={() => {
      setConfirmAction(false);
  
      handleValidationForSelectedList(
        pendingSelection.list,
        pendingSelection.name
      );
  
      setPendingSelection({
        list: [],
        name: '',
      });
    }}
  />
    </>
  );
};
export default CalculateInterestSearch;
